import { render, staticRenderFns } from "./nextScreen.vue?vue&type=template&id=ee2f0d08&scoped=true&"
import script from "./nextScreen.vue?vue&type=script&lang=js&"
export * from "./nextScreen.vue?vue&type=script&lang=js&"
import style0 from "./nextScreen.vue?vue&type=style&index=0&id=ee2f0d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2f0d08",
  null
  
)

export default component.exports